var NATIVE_SYMBOL = require('../internals/native-symbol');

/* eslint-disable es-x/no-symbol -- safe */
module.exports = NATIVE_SYMBOL && !!Symbol['for'] && !!Symbol.keyFor;



//////////////////
// WEBPACK FOOTER
// ./~/core-js/internals/native-symbol-registry.js
// module id = 473
// module chunks = 0